<div class="switcher">
  <input
    [id]="items[0].value + uniqId"
    [name]="'switcher1' + uniqId"
    [value]="items[0].value"
    [(ngModel)]="currVal"
    type="radio"
    checked="true"
    (change)="change($event)"
  />
  <label [for]="items[0].value + uniqId">{{ items[0].label }}</label>
  <input
    [id]="items[1].value + uniqId"
    [name]="'switcher2' + uniqId"
    [value]="items[1].value"
    [(ngModel)]="currVal"
    type="radio"
    (change)="change($event)"
  />
  <label [for]="items[1].value + uniqId">{{ items[1].label }}</label>
  <div class="switcher__bg"></div>
</div>
